import { render, staticRenderFns } from "./excellentcases.vue?vue&type=template&id=31182e4b&scoped=true&"
import script from "./excellentcases.vue?vue&type=script&lang=js&"
export * from "./excellentcases.vue?vue&type=script&lang=js&"
import style0 from "./excellentcases.vue?vue&type=style&index=0&id=31182e4b&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31182e4b",
  null
  
)

export default component.exports